import cls from 'classnames';
import useStyles from './styles';
import { CenteredContainerProps, CenteredContainerType } from './types';

export default function CenteredContainer({
  type = CenteredContainerType.large,
  children,
  className,
}: CenteredContainerProps) {
  const classes = useStyles({ type });

  return <div className={cls(classes.root, className)}>{children}</div>;
}
